import { urlHomepageBackground } from '../../../../server/utils/urlConstants';
import { routeTheGrapefulClub } from '../../../../server/utils/routeConstants';

// Promotion Banners

export const grillAndChill = {
  type: 'dynamicTile',
  enabled: true,
  key: 'grillAndChill',
  images: {
    alt: 'Preferred Customer Exclusive',
    desktop: {
      src: `${urlHomepageBackground}GrillChill_desktop_1440.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}GrillChill_tablet_615x800.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}GrillChill_mobile_320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Preferred Customer Exclusive',
  header: 'Grill & Chill',
  summary: `Celebrate the last few days of summer with our 90+ point winning wines! For a limited time enjoy this special curated mixed pack - the perfect pairings for your summer BBQ!`,
  buttonText: `Get Up to 30% Off`,
  buttonLink: 'shop/wine/wine-collection-award-winning', // replace with Award Winning slug
  // buttonTwoText: `Shop Now`,
  // buttonTwoLink: `/shop/product/2-bottle-etched-wood-box-pp-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const sipSpringPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'sipSpringPromo',
  images: {
    alt: 'Sip into spring promo',
    desktop: {
      src: `${urlHomepageBackground}IWD20_2_desktop_2400x2400.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}IWD20_2_tablet_1152x1668.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}IWD20_2_mobile_960x924.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: '',
  header: 'Sunshine Sips & Patio Picks',
  summary: `Hello spring! Enjoy up to 35% off our seasonal six-packs of award-winning wines, plus $10 shipping!`,
  subSummary: ``,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/sale',
  // buttonTwoText: `Shop Now`,
  // buttonTwoLink: `/shop/product/2-bottle-etched-wood-box-pp-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const aprPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'aprPwpPromo',
  images: {
    alt: 'Get 50% Off The Three Muscat-eers Pack!',
    desktop: {
      src: `${urlHomepageBackground}ThreeMuscateers_1440-min.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}ThreeMuscateers_768.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}ThreeMuscateers_320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: '',
  header: 'Get 50% Off The Three Muscat-eers Pack!',
  summary: `Purchase 6 or more wines and unlock this seasonal trio at half off!`,
  subSummary: ``,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  // buttonTwoText: `Shop Now`,
  // buttonTwoLink: `/shop/product/2-bottle-etched-wood-box-pp-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const mayPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'mayPwpPromo',
  images: {
    alt: 'Enjoy 35% Off Our Fresh Picked Pack!',
    desktop: {
      src: `${urlHomepageBackground}FreshPicked_desktop-min.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}FreshPicked_tablet-min.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}FreshPicked_mobile-min.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: '',
  header: 'Enjoy 35% Off Our Fresh Picked Pack!',
  summary: `Add 6 or more bottles to your cart and unlock this limited-edition trio for 35% off!`,
  subSummary: ``,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  // buttonTwoText: `Shop Now`,
  // buttonTwoLink: `/shop/product/2-bottle-etched-wood-box-pp-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const junePwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'junePwpPromo',
  images: {
    alt: 'Our Rainbow Glitter Brut is Back!',
    desktop: {
      src: `${urlHomepageBackground}Pride_Promo_Desktop-min.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}Pride_Promo_Tablet-min.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}Pride_Promo_Mobile-min.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: '',
  header: 'Our Rainbow Glitter Brut is Back!!',
  summary: `Get $30 off our limited edition Pour With Pride when you add 6+ bottles to your cart!`,
  subSummary: ``,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  // buttonTwoText: `Shop Now`,
  // buttonTwoLink: `/shop/product/2-bottle-etched-wood-box-pp-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const julyPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'julyPwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}PwP_July_Desktop-min.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}PwP_July_Tablet-min.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}PwP_July_Mobile-min.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  // miniHeader: '',
  header: 'Celebrate Summer with 50% off our Sunkissed Sips 3-Pack!',
  summary: `Add 6 or more bottles to your cart and unlock this limited-edition trio for $35!`,
  promoText: `*Limit 1 per order while supplies last. Sale ends 7/31/20.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const augPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'augPwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}Aug1_Homepage_Promo_Desktop-min.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}Aug1_Homepage_Promo_Tablet-min.jpg`,
      height: 591,
      width: 384,
    },
    mobile: {
      src: `${urlHomepageBackground}Aug1_Homepage_Promo_Mobile-min.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: 'Treat yourself to 40% off our Frosé and Friends Pack!',
  summary: `For a limited time, add 6+ bottles to your cart and unlock this exclusive offer so you can stay home and stay cool! This pack includes: one Vintner Pinot Noir, one California Rosé, one Vintner Sparkling Rosé, one Rosé All Day plastic tumbler, and one Frosé ice tray.`,
  // promoText: `*Limit 1 per order while supplies last. Sale ends 7/31/20.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const sepPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'sepPwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}Sept_PwP_Desktop-min.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}Sept_PwP_Tablet-min.jpg`,
      height: 591,
      width: 384,
    },
    mobile: {
      src: `${urlHomepageBackground}Sept_PwP_Mobile-min.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: 'Savor the season with over $40 off our Endless Summer Duo!',
  summary: `Keep the sandy, sunkissed vibes going with our refreshing Rutherford Estate Fumé Blanc and our rich Napa Valley Cabernet Sauvignon. Add 6+ bottles to your cart and unlock this exclusive offer while supplies last!`,
  // promoText: `*Limit 1 per order while supplies last. Sale ends 7/31/20.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const octPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'octPwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}Oct1_Promo_Desktop-min.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}Oct1_Promo_Tablet-min.jpg`,
      height: 591,
      width: 384,
    },
    mobile: {
      src: `${urlHomepageBackground}Oct1_Promo_Mobile-min.jpg`,
      height: 640,
      width: 640,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: 'Sip & Save! Get 40% off our Breast Friend Trio!',
  summary: `This October, add 6+ bottles to your cart and unlock this exclusive trio to help fund clinical trials for breast cancer.`,
  // promoText: `*Limit 1 per order while supplies last. Sale ends 7/31/20.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const novPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'novPwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}November20_Promo_Desktop-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}November20_Promo_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}November20_Promo_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: 'Enjoy 50% off our Holiday Hope Pack',
  summary: `‘Tis the season for giving! Add 6+ bottles to your cart and unlock our limited-edition Holiday Hope Pack at 50% off! Every purchase helps fund grants for families with special needs children through the ONEHOPE Foundation. `,
  promoText: `**Limit 2 per 6+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const decPwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'decPwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}December_Promo_Desktop-min-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}December_Promo_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}December_Promo_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: 'Get 50% off our Milestone Mixed Pack!',
  summary: `We’re celebrating an amazing year of impact with a limited-time offer! Add 6+ bottles to your cart and unlock our Milestone Mixed Pack featuring our $5M Anniversary Cabernet Sauvignon that’s exclusive to this pack!`,
  promoText: `*Available 12/1/20-12/31/20. Limit 2 per 6+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const jan21PwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'jan21PwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}Jan21_Promo_Desktop-min-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}Jan21_Promo_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}Jan21_Promo_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: 'This Month Only Get 50% Off Our Winning Wines Pack!',
  summary: `Stock up and cozy in! Add 6+ bottles to your cart and unlock our limited-edition Winning Wines Pack, featuring three 90+ point wines from our Vintner Collection!`,
  promoText: `*Offer available 1/1/21 - 1/31/21. Limit 2 per 6+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const feb21PwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'feb21PwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}Feb21PwP_Desktop-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}Feb21PwP_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}Feb21PwP_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: 'Join Us on Cloud Wine With 50% Off Our Love Pack!',
  summary: `For a limited time, add 6+ bottles to your cart to unlock this swoon-worthy deal! Every pack supports heart health, so you can pour with purpose. `,
  promoText: `**Offer available 2/1/21-2/28/21. Limit 2 per 6+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const mar21PwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'mar21PwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}Mar21_Promo_Desktop-min-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}Mar21_Promo_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}Mar21_Promo_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: `Celebrate Women's History Month With 50% Off Our HerStory Pack!`,
  summary: `For a limited time, add 6+ bottles to your cart to unlock the HerStory Pack at 50% off! What better way to celebrate the women in your life than with wine?`,
  promoText: `**Offer available 3/1/21-3/31/21. Limit 2 per 6+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const apr21PwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'apr21PwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}Apr21Promo_Desktop-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}Apr21Promo_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}Apr21Promo_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: `Celebrate Earth Day With 50% Off Our Roots Pack!`,
  summary: `For a limited time, add 6+ bottles to your cart to unlock the Roots Pack at 50% off! Every Roots Pack helps to plant trees through our global reforestation project.`,
  promoText: `***Offer available 4/1/21-4/30/21. Limit 2 per 6+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const may21PwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'may21PwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}May21_Promo_Desktop-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}May21_Promo_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}May21_Promo_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: `Get 50% Off This Month’s Cause Pack`,
  summary: `For a limited time, add 6+ bottles to your cart to unlock this month’s Cause Pack at 50% off! Every Cause Pack supports our giving pillars: water, hunger relief, health, and education.`,
  promoText: `*Offer available 5/1/21-5/31/21. Limit 2 per 6+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};

export const june21PwpPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'june21PwpPromo',
  images: {
    alt: '',
    desktop: {
      src: `${urlHomepageBackground}June21_Promo_Desktop-min.jpg`,
      height: 2400,
      width: 2400,
    },
    tablet: {
      src: `${urlHomepageBackground}June21_Promo_Tablet-min.jpg`,
      height: 1410,
      width: 1152,
    },
    mobile: {
      src: `${urlHomepageBackground}June21_Promo_Mobile-min.jpg`,
      height: 960,
      width: 960,
    },
  },
  // overlayLogo: {
  //   alt: 'New Logo',
  //   src: `${urlHomepageBackground}new-logo.png`,
  //   height: 154,
  //   width: 154,
  // },
  miniHeader: 'PROMOTION OF THE MONTH ',
  header: `Enjoy 2 Bottles for $0.14 for our 14th birthday!`,
  summary: `We want to include our customers in the celebration of 14 years of giving back. In honor of our birthday month, purchase 12+ bottles at 20% off and get 2 bottles for only 14 cents!`,
  promoText: `*Offer available 6/1/21-6/30/21. Limit 1 per 12+ bottle order while supplies last.`,
  buttonText: `SHOP NOW`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
};


export const bronzeGlitterPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'bronzeGlitterPromo',
  images: {
    alt: 'All-new limited edition Bronze Glitter Pinot Noir',
    desktop: {
      src: `${urlHomepageBackground}Bronze_Promo_Desktop.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}Bronze_Promo_Tablet.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}Bronze_promo_Mobile.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Limited-Edition',
  header: 'Bronze Vintner Pinot Noir',
  summary: `Raise a glass for good this season and help fund pet adoptions with our limited edition Vintner Pinot Noir Bronze Glitter bottle.`,
  subSummary: `Customer Price: $59`,
  buttonText: `Shop Now`,
  buttonLink:
    '/shop/product/vintner-collection-ca-pinot-noir-bronze-glitter-edition-pc',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: 'Preferred Customer Price: $49',
};

export const goldShimmerPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'goldShimmerPromo',
  images: {
    alt: 'Gold Shimmer is now $29!',
    desktop: {
      src: `${urlHomepageBackground}GoldShimmerV3Desktop_1600x1600.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}GoldShimmerV3Tablet_768x1112.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}GoldShimmerV3Mobile_640x640.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'LIMITED-Time offer',
  header: 'Gold Shimmer now $29',
  summary: `The holidays are a time for gathering, gifting, and giving back. Celebrate this holiday season with our unique Gold Shimmer bottle, now $29 while supplies last. `,
  subSummary: `<span style='font-size:10px; font-weight:500; letter-spacing: 0.5px;  line-height: 1.4;font-style: italic;' >This bottle helps fund healthy meals to end hunger.</span>`,
  buttonText: `Shop Now`,
  buttonLink:
    '/shop/product/california-brut-sparkling-wine-gold-shimmer-edition',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const holidayMagnumPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'holidayMagnumPromo',
  images: {
    alt: 'Exclusive holiday Gather & Give magnums',
    desktop: {
      src: `${urlHomepageBackground}MagnumPromo_desktop_2400x2400.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}MagnumPromo_tablet_1152x1668.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}MagnumPromo_mobile_960x960.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Preferred Customer exclusive',
  header: 'Limited Edition Holiday Gather & Give Magnum',
  summary: `With the purchase of a 6 or 12 pack, Preferred Customers unlock access to our exclusive, limited edition Holiday Gather and Give Magnum bottle for only $25 + $5 shipping. `,
  subSummary: `<span style='font-size:10px; font-weight:500; letter-spacing: 0.5px;  line-height: 1.4;font-style: italic;' >Limit one per order, while supplies last.</span>`,
  buttonText: `Shop Now`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const freeShippingGiftsPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'freeShippingGiftsPromo',
  images: {
    alt: 'Free shipping on gifts!',
    desktop: {
      src: `${urlHomepageBackground}FreeShippingGifts_resized_desktop_2400x2400.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}FreeShippingGifts_resized_tablet_1152x1668.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}FreeShippingGifts_resized_mobile_640x640.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'TWO DAYS ONLY',
  header: 'Free shipping on gifts',
  summary: `For December 10 and 11th ONLY, get free shipping on all *gifts!<br><br>

  <strong>Hanukkah Shipping deadline:</strong> <br>
  December 15
  <br><br>
  <strong>Christmas shipping deadline: </strong> <br>
  December 17`,
  subSummary: `<span style='font-size:10px; font-weight:500; letter-spacing: 0.5px;  line-height: 1.4;font-style: italic;' >Excludes corporate gifting.</span>`,
  buttonText: `Shop Now`,
  buttonLink: '/shop/gifts/gifts',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const sparkling4PackPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'sparkling4PackPromo',
  images: {
    alt: 'Get our Sparkling 4-Pack!',
    desktop: {
      src: `${urlHomepageBackground}Sparkling4PackPromo_resized_desktop_2400x2400.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}Sparkling4PackPromo_resized_tablet_1152x1668.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}Sparkling4PackPromo_resized_mobile_960x960.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'TWO DAYS ONLY',
  header: '4-pack of bubbly is 20% off!',
  summary: `Preferred Customers get this limited edition bubbly 4-pack to ring in the new year for 20% off!`,
  subSummary: `<span style='font-size:10px; font-weight:500; letter-spacing: 0.5px;  line-height: 1.4;font-style: italic;'>Sale ends midnight PST 12/19/19</span>`,
  buttonText: `Shop Now`,
  buttonLink: '/shop/product/bubbly-4-pack',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const freePCMembershipPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'sparkling4PackPromo',
  images: {
    alt: 'Subscribe and get a free Preferred Customer membership!',
    desktop: {
      src: `${urlHomepageBackground}FreePCSubscribe_Desktop_resized_2400x2400.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}FreePCSubscribe_tablet_resized_1152x1668.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}FreePCSubscribe_mobile_resized_960x960.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Preferred Customer offer',
  header: 'Free Preferred Customer membership when you subscribe',
  summary: `Sign up as a Preferred Customer today and when you subscribe to a 6 or 12 pack, your first year membership fee is waived!`,
  subSummary: `<span style='font-size:10px; font-weight:500; letter-spacing: 0.5px;  line-height: 1.4;font-style: italic;'>Offer valid through March 31, 2020</span>`,
  buttonText: `Learn More`,
  buttonLink: '/preferred',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const blackFridayPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'blackFridayPromo',
  images: {
    alt: 'Shop our Black Friday Sale',
    desktop: {
      src: `${urlHomepageBackground}BF_PC_Desktop_1660x1660.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}BF_PC_Tablet_768x1112.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}BF_PC_Mobile_640x640.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Black Friday Sale!!!',
  header: 'More than 40% off',
  summary: `With the purchase of a 6 or 12 pack, Preferred Customers receive up to 40% off, free bags and tags*, and exclusive access to our Holiday Magnum Cabernet for $25.*`,
  subSummary: `<span style='font-size:10px; font-weight:500; letter-spacing: 0.5px;  line-height: 1.4;font-style: italic;' >*While supplies last</span>`,
  buttonText: `Shop Now`,
  buttonLink: '/shop/wine/wine',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const pinkGlitterChardPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'pinkGlitterChardPromo',
  images: {
    alt:
      'Show your support for BCAM with our limited-edition Pink Glitter Vintner Chardonnay',
    desktop: {
      src: `${urlHomepageBackground}promo-pinkglitter-1400.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}promo-pinkglitter-615x800.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}promo-pinkglitter-320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Limited-Edition Glitter',
  header: 'Pink Glitter Vintner Chardonnay',
  summary: `October is Breast Cancer Awareness Month! Show your support with every bottle of our limited-edition Pink Glitter Vintner Chardonnay.`,
  subSummary: `Customer Price: $59`,
  buttonText: `Shop Now`,
  buttonLink:
    '/shop/product/vintner-collection-california-chardonnay-pink-glitter-edition-pc',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: 'Preferred Customer Price: $49',
};

export const endlessSummerPromo = {
  type: 'dynamicTile',
  enabled: true,
  key: 'endlessSummerPromo',
  images: {
    alt: 'Now through October 1, save 25% on the Endless Summer Pack',
    desktop: {
      src: `${urlHomepageBackground}EndlessSummerPromo_1440.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}EndlessSummerPromo_615x800.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}EndlessSummerPromo_2_320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Preferred Customer Sale',
  header: 'Endless Summer Mixed Pack',
  summary: `The days may be getting shorter but summer doesn't have to end! <strong>Save 25%</strong> on five varietals, plus get a <strong>free</strong> water bottle! On sale now through October 1. `,
  buttonText: `Shop Now`,
  buttonLink: '/shop/product/endless-summer-mixed-pack-pc',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const halfOffTastingEvent = {
  type: 'dynamicTile',
  enabled: true,
  key: 'halfOffTastingEvent',
  images: {
    alt: 'Now through September 30, get half-off host kits!',
    desktop: {
      src: `${urlHomepageBackground}septemberHostPromo_1600.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}septemberHostPromo_615x800.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}septemberHostPromo_320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Sip-tember Savings',
  header: 'Host a tasting for 50% off!',
  summary: `For a limited time, get a host kit starting at $49- shipping included! Order now, this offer ends September 30.`,
  buttonText: `Host a Tasting`,
  buttonLink: '/host',
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '',
};

export const leAnnRimes = {
  type: 'dynamicTile',
  enabled: true,
  key: 'leAnnRimes',
  images: {
    alt: 'Introducing our LeAnn Rimes Signature Series Cabernet Sauvignon',
    desktop: {
      src: `${urlHomepageBackground}leann_rimes_1600x1600.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}leann_rimes_615x800.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}leann_rimes_320x320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Limited-Edition Bottle',
  header: 'LeAnn Rimes + ONEHOPE',
  summary: `For a limited time get the special-edition LeAnn Rimes Paso Robles Cabernet Sauvignon. Together we support the PEDIGREE Foundation.`,
  buttonText: `Shop Now`,
  buttonLink:
    '/shop/product/leann-rimes-signature-series-paso-robles-cabernet-sauvignon', // replace with LeAnn Rimes slug
  // buttonTwoText: `Shop Now`,
  // buttonTwoLink: `/shop/product/2-bottle-etched-wood-box-pp-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: 'LeAnn Rimes Signature Series $40',
};

export const pinotForPawsEtching = {
  type: 'dynamicTile',
  enabled: true,
  key: 'pinotForPawsEtching',
  images: {
    alt:
      'Join the Grapeful Club to access our limited-edition Pinot for Paws Etched Gift Boxes!',
    desktop: {
      src: `${urlHomepageBackground}pinot4paws_etched_desktop_1440.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}pinot4paws_etched_tablet_615x800.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}pinot4paws_etched_mobile_320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Limited-Edition Etched Box',
  header: 'Celebrate the fur babies',
  summary: `For a limited time get a 2-bottle wood box etched with your choice of five different pet-inspired designs- available to Preferred Customers only!`,
  buttonText: `Join the Grapeful Club`,
  buttonLink: '/preferred',
  buttonTwoText: `Shop Now`,
  buttonTwoLink: `/shop/product/2-bottle-etched-wood-box-pp-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: 'Preferred Customer Price $69.99',
};

export const rwbGlitterBottleNewLayout = {
  type: 'dynamicTile',
  enabled: true,
  key: 'rwbGlitterBottleNewLayout',
  images: {
    alt:
      'Join the Grapeful Club to access our limited-edition Red, White, & Blue 12-pack!',
    desktop: {
      src: `${urlHomepageBackground}RWBGlitter_NewLayout_1440.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}RWBGlitter_NewLayout_615x800.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}RWBGlitter_NewLayout_320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Limited edition glitter',
  header: 'Sparkle all summer',
  summary: `Preferred Customers save $10 on the limited-edition Red, White & Blue Glitter Sparkling Brut. Available for a limited time only!`,
  buttonText: `Join the Grapeful Club`,
  buttonLink: '/preferred',
  buttonTwoText: `Shop Now`,
  buttonTwoLink: `/shop/product/celebration-brut-sparkling-wine-red-white-blue-glitter-edition-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: 'Grapeful Club Price $49',
};

export const SummerIsLit = {
  type: 'dynamicTile',
  enabled: true,
  key: 'SummerIsLit',
  images: {
    alt:
      'Join the Grapeful Club to access our limited-edition Red, White, & Blue 12-pack!',
    desktop: {
      src: `${urlHomepageBackground}summer_is_lit_1440.jpg`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}summer_is_lit_1229x1600.jpg`,
      height: 1600,
      width: 1229,
    },
    mobile: {
      src: `${urlHomepageBackground}summer_is_lit_320.jpg`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Stock up and save!',
  header: 'This summer is gonna be lit',
  summary: `Join the Grapeful Club to access our limited-edition Red, White & Blue 12-pack!`,
  buttonText: `Join the Grapeful Club`,
  buttonLink: '/preferred',
  buttonTwoText: `Shop 12-pack`,
  buttonTwoLink: `/shop/product/red-white-brut-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '$298 + $10 Shipping',
};

export const CelebratePrideMonth = {
  type: 'dynamicTile',
  enabled: true,
  key: 'CelebratePrideMonth',
  images: {
    alt: 'glitter bottles animation',
    desktop: {
      src: `${urlHomepageBackground}gc-pride-d.gif`,
      height: 1600,
      width: 1600,
    },
    tablet: {
      src: `${urlHomepageBackground}gc-pride-t.gif`,
      height: 1229,
      width: 1600,
    },
    mobile: {
      src: `${urlHomepageBackground}gc-pride-m.gif`,
      height: 640,
      width: 640,
    },
  },
  overlayLogo: {
    alt: 'New Logo',
    src: `${urlHomepageBackground}new-logo.png`,
    height: 154,
    width: 154,
  },
  miniHeader: 'Celebrate pride month!',
  header: 'Pour with pride',
  summary: `Join the Grapeful Club to access our limited-edition Pride 4-pack!`,
  buttonText: `Join the Grapeful Club`,
  buttonLink: '/preferred',
  buttonTwoText: `Shop Pride 4-pack`,
  buttonTwoLink: `/shop/product/pride-4-pack-pc`,
  textAlign: 'left',
  isTextBoxOverlay: true,
  imageSide: 'right',
  promoText: '$135 + $10 Shipping',
};

export const MakeADifference = {
  type: 'dynamicTile',
  enabled: true,
  key: 'MakeADifference',
  images: {
    alt: 'girls drinking wine',
    desktop: {
      src: `${urlHomepageBackground}impact_desktop.jpg`,
      height: 1280,
      width: 1440,
    },
    tablet: {
      src: `${urlHomepageBackground}impact_tablet.jpg`,
      height: 768,
      width: 1536,
    },
    mobile: {
      src: `${urlHomepageBackground}impact_mobile.jpg`,
      height: 320,
      width: 320,
    },
  },
  textWrapperImage: {
    alt: '10 year Cabernet',
    src: `${urlHomepageBackground}10-yr-cab@2x.jpg`,
    height: 340,
    width: 130,
  },
  header: 'Making a difference, one bottle at a time',
  summary: `Most recently, you helped us raise enough funds from our 10 year Cabernet to build a school in Guatemala with Pencils of Promise!`,
  buttonText: `Shop the Cause`,
  buttonLink: '/shop/product/onehope-10-year-california-cabernet-sauvignon',
  imageSide: 'left',
  textAlign: 'left',
  headerTextAlign: 'left',
  miniTextOverlay: 'hope in action',
  textOverlay: 'Together, we built a school!',
  buttonOverlayText: 'more about the school',
  buttonOverlayLink: 'https://pop.onehopewine.com/',
};

export const RaiseAGlassForGood = {
  type: 'dynamicTile',
  enabled: true,
  key: 'RaiseAGlassForGood',
  header: 'Raise a glass for good',
  summary: `Invite friends over to taste award-winning wine while earning rewards redeemable for ONEHOPE wine, swag, and other amazing items.`,
  subSummary: `Donate 10% of event proceeds to your charity of choice!`,
  buttonText: `Host a Wine Tasting`,
  buttonLink: '/host',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Group of women raise a glass of wine for a good cause',
    desktop: {
      src: `${urlHomepageBackground}raise-glass_desktop.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}raise-glass_tablet.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}raise-glass_mobile.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const RaiseAGlassForGood20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'RaiseAGlassForGood20',
  header: 'Raise a glass for good',
  summary: `Invite friends over to taste award-winning wine while earning rewards redeemable for ONEHOPE wine, kitchen products and other amazing items. `,
  subSummary: `Donate 10% of event proceeds to your charity of choice!`,
  buttonText: `Host a Wine Tasting`,
  buttonLink: '/host',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Group of women raise a glass of wine for a good cause',
    desktop: {
      src: `${urlHomepageBackground}IWD20_4_desktop_2160x1920.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}IWD20_4_tablet_2304x1152.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}IWD20_4_mobile_960x720.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const HostAVirtualTasting = {
  type: 'dynamicTile',
  enabled: true,
  key: 'HostAVirtualTasting',
  header: 'Host a Virtual Tasting',
  summary: `Invite friends and family to an online wine tasting and raise money for a cause you’re passionate about. 10% of qualified event proceeds will be donated to a 501(c)3 nonprofit of your choice. `,
  subSummary: ``,
  buttonText: `Learn More`,
  buttonLink: '/host',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Group of women raise a glass of wine for a good cause',
    desktop: {
      src: `${urlHomepageBackground}OnlineEvents_desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}OnlineEvents_tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}OnlineEvents_mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const HostAVirtualTastingSep20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'HostAVirtualTasting',
  header: 'Host a Virtual Tasting',
  summary: `Invite friends and family to an online wine tasting and raise money for a cause you’re passionate about. 10% of qualified event proceeds will be donated to a 501(c)3 nonprofit of your choice. `,
  subSummary: ``,
  buttonText: `Learn More`,
  buttonLink: '/host',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Host a virtual tasting!',
    desktop: {
      src: `${urlHomepageBackground}VirtualTasting2_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}VirtualTasting2_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}VirtualTasting2_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const HostAVirtualTastingOct20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'HostAVirtualTastingOct20',
  header: 'Host a Virtual Tasting',
  summary: `Invite friends and family to an online wine tasting and raise money for a cause you’re passionate about. 10% of qualified event proceeds will be donated to a 501(c)3 nonprofit of your choice. `,
  subSummary: ``,
  buttonText: `Learn More`,
  buttonLink: '/host',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Host a virtual tasting!',
    desktop: {
      src: `${urlHomepageBackground}Oct1_VirtualTasting_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Oct1_VirtualTasting_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Oct1_VirtualTasting_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const HostAVirtualTastingDec20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'HostAVirtualTastingDec20',
  header: 'Host a Virtual Tasting',
  summary: `Invite friends and family to an online wine tasting and raise money for a cause you’re passionate about. 10% of event proceeds will be donated to a 501(c)3 nonprofit of your choice. `,
  subSummary: ``,
  buttonText: `Learn More`,
  buttonLink: '/host',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Host a virtual tasting!',
    desktop: {
      src: `${urlHomepageBackground}December_VirtualTasting_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}December_VirtualTasting_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}December_VirtualTasting_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const HostAVirtualTastingFeb21 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'HostAVirtualTastingFeb21',
  header: 'Host a Virtual Tasting',
  summary: `Invite friends and family to an online wine tasting and raise money for a cause you’re passionate about. 10% of event proceeds will be donated to a 501(c)3 nonprofit of your choice. `,
  subSummary: ``,
  buttonText: `Learn More`,
  buttonLink: '/host',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Host a virtual tasting!',
    desktop: {
      src: `${urlHomepageBackground}Feb21VirtualTasting_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Feb21VirtualTasting_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Feb21VirtualTasting_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const consciousKidTile = {
  type: 'dynamicTile',
  enabled: true,
  key: 'consciousKidTile',
  header: 'Help Fund Anti-Racism Books for Children',
  miniHeader: `Featured Fundraiser`,
  summary: `The systemic racism and injustice in our society cannot be tolerated, and we must all do our part to stand in solidarity with the Black community. Educating children about equality and how to be actively anti-racist is imperative to nourishing the future. That’s why we’ve partnered with The Conscious Kid to help fund resources for children and their families to learn more about reducing bias. Visit our fundraiser page below where 10% of every purchase gives back to this incredible organization.`,
  subSummary: ``,
  buttonText: `Support the Cause`,
  buttonLink: '/conscious',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Help fund anti-racism books for kids',
    desktop: {
      src: `${urlHomepageBackground}ConsciousKid_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}ConsciousKid_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}ConsciousKid_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const whyHungerTile = {
  type: 'dynamicTile',
  enabled: true,
  key: 'whyHungerTile',
  header: 'Help fund meals for children in need',
  miniHeader: `Featured Fundraiser`,
  summary: `Over 30 million kids across America rely on free and reduced-price school meals for their daily nutrition. In the summer, many of these children go hungry when class is not in session, and with COVID-19 closures and skyrocketing unemployment rates, the need is greater than ever. Shop to support our fundraiser where 10% of every purchase gives back to WhyHunger, a nonprofit organization dedicated to helping children and their families find nutritious meals locally. Together we can nourish the future.`,
  subSummary: ``,
  buttonText: `Support the Cause`,
  buttonLink: '/hunger',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Help fund meals for children in need',
    desktop: {
      src: `${urlHomepageBackground}Aug1_Homepage_Fundraiser_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Aug1_Homepage_Fundraiser_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Aug1_Homepage_Fundraiser_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const susanKomenTile = {
  type: 'dynamicTile',
  enabled: true,
  key: 'susanKomenTile',
  header: 'Shop the Susan G. Komen® Fundraiser',
  miniHeader: `Featured Fundraiser`,
  summary: `As National Breast Cancer Awareness Month approaches, we at ONEHOPE want to give moments of hope to families impacted by breast cancer. That’s why we’re partnering with Susan G. Komen to support their mission to find the cures for breast cancer. Shop our fundraiser and help us reach our goal of donating $50,000 to this incredible organization.`,
  subSummary: ``,
  buttonText: `Support the Cause`,
  buttonLink: '/komen',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Shop to support the Susan G. Komen® Fundraiser',
    desktop: {
      src: `${urlHomepageBackground}SusanKomen_Homepage_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}SusanKomen_Homepage_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}SusanKomen_Homepage_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const susanKomenTileOct = {
  type: 'dynamicTile',
  enabled: true,
  key: 'susanKomenTileOct',
  header: 'Shop the Susan G. Komen® Fundraiser',
  miniHeader: `Featured Fundraiser`,
  summary: `For National Breast Cancer Awareness Month, we at ONEHOPE want to give moments of hope to families impacted by breast cancer. That’s why we’re partnering with Susan G. Komen to support their mission to find the cures for breast cancer. Shop our fundraiser and help us reach our goal of donating $50,000 to this incredible organization.`,
  subSummary: ``,
  buttonText: `Support the Cause`,
  buttonLink: '/komen',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Shop to support the Susan G. Komen® Fundraiser',
    desktop: {
      src: `${urlHomepageBackground}SusanKomen_Homepage_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}SusanKomen_Homepage_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}SusanKomen_Homepage_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const holiday20Fundraiser = {
  type: 'dynamicTile',
  enabled: true,
  key: 'holiday20Fundraiser',
  header: 'Support Families with Special Needs Children this Season',
  miniHeader: `Featured Fundraiser`,
  summary: `Due to the pandemic, children with special needs are facing both school closures and disruptions to their in-person therapy sessions, making this time even harder on them and their families. Shop our fundraiser where 10% of every purchase will help fund grants to create a little holiday magic for these families. `,
  subSummary: ``,
  buttonText: `Support the Cause`,
  buttonLink: '/holiday-magic',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Support Families with Special Needs Children this Season',
    desktop: {
      src: `${urlHomepageBackground}November20_Fundraiser_Desktop-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}November20_Fundraiser_Tablet-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}November20_Fundraiser_Mobile-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const january21Fundraiser = {
  type: 'dynamicTile',
  enabled: true,
  key: 'january21Fundraiser',
  header: 'Shop our Pencils of Promise Fundraiser',
  miniHeader: `Featured Fundraiser`,
  summary: `In honor of National Mentoring Month, we’re partnering with Pencils of Promise, an organization dedicated to creating schools, programs, and global communities around the common goal of education for all. Shop this month’s fundraiser where 10% of every purchase gives back to their Teacher Support Program.`,
  subSummary: ``,
  buttonText: `Shop to Support the Cause`,
  buttonLink: '/mentor-month',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Support Families with Special Needs Children this Season',
    desktop: {
      src: `${urlHomepageBackground}Jan21_Fundraiser_Desktop-min-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}Jan21_Fundraiser_Tablet-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}Jan21_Fundraiser_Mobile-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const feb21Fundraiser = {
  type: 'dynamicTile',
  enabled: true,
  key: 'feb21Fundraiser',
  header: 'Support Our Equal Justice Initiative Fundraiser',
  miniHeader: `Featured Fundraiser`,
  summary: `In honor of Black History Month, we’re raising funds for the Equal Justice Initiative, an organization dedicated to ending mass incarceration and excessive punishment, challenging racial and economic injustice, and protecting basic human rights for the most vulnerable people in American society. Shop our ONEHOPE Foundation Fundraiser, where 10% of every purchase gives back to EJI’s Community Remembrance Project.`,
  subSummary: ``,
  buttonText: `Shop to Support the Cause`,
  buttonLink: '/eji',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Shop to support the equal justice initiative',
    desktop: {
      src: `${urlHomepageBackground}Feb21Fundraiser_Desktop-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}Feb21Fundraiser_Tablet-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}Feb21Fundraiser_Mobile-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const mar21Fundraiser = {
  type: 'dynamicTile',
  enabled: true,
  key: 'mar21Fundraiser',
  header: `Support Our charity: water Fundraiser`,
  miniHeader: `Featured Fundraiser`,
  summary: `This March, in honor of World Water Day, we’re raising money for charity: water, a non-profit organization helping to bring clean and safe drinking water to people in developing countries. Why water? Because clean water changes everything. 

  <br><br>To join us in support of charity: water, shop this month’s ONEHOPE Foundation Fundraiser, where 10% of your purchase will go directly to bringing clean and safe drinking water to people in developing countries.`,
  subSummary: ``,
  buttonText: `Shop to Support the Cause`,
  buttonLink: '/charitywater',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Shop to support charity:water',
    desktop: {
      src: `${urlHomepageBackground}Mar21_CharityWater_Desktop-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}Mar21_CharityWater_Tablet-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}Mar21_CharityWater_Mobile-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const apr21Fundraiser = {
  type: 'dynamicTile',
  enabled: true,
  key: 'arp21Fundraiser',
  header: `Fund Scholarships for Students with Autism`,
  miniHeader: `Featured Fundraiser`,
  summary: `The Organization for Autism Research is a collection of people working to fund research and programs that directly benefit the lives of individuals with autism.
  <br><br>
  Join us by shopping or hosting an event for this month’s ONEHOPE Foundation Fundraiser, where 10% of your purchase will go toward funding an additional $5,000 scholarship.`,
  subSummary: ``,
  buttonText: `Shop to Support the Cause`,
  buttonLink: '/oar',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Shop to support charity:water',
    desktop: {
      src: `${urlHomepageBackground}Apr21Fundraiser_Desktop-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}Apr21Fundraiser_Tablet-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}Apr21Fundraiser_Mobile-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const may21Fundraiser = {
  type: 'dynamicTile',
  enabled: true,
  key: 'may21Fundraiser',
  header: `MindUP For Life | The Goldie Hawn Foundation`,
  miniHeader: `Featured Fundraiser`,
  summary: `MindUP for Life is a not-for-profit organization founded to help children develop the mental fitness necessary to thrive in school, work, and life. ONEHOPE has already donated $25,000 to fund MindUP’s acclaimed curriculum. Shop our fundraiser where 10% of every purchase will help raise funds for MindUP’s educational programs.`,
  subSummary: ``,
  buttonText: `Shop to Support the Cause`,
  buttonLink: '/mindup',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Shop to support charity:water',
    desktop: {
      src: `${urlHomepageBackground}May21_Fundraiser_Desktop-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}May21_Fundraiser_Tablet-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}May21_Fundraiser_Mobile-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const june21Fundraiser = {
  type: 'dynamicTile',
  enabled: true,
  key: 'june21Fundraiser',
  header: `Help Fund Meals for Children in Need`,
  miniHeader: `Featured Fundraiser`,
  summary: `This summer, we’re raising money to support WhyHunger’s Summer Meals Program that connects children and their families to free, nutritious meals close to home. ONEHOPE has donated $50,000, connecting 29,950 children and their families to nutritious meals. 

  <br><br>Join us in support of WhyHunger’s work by shopping this month’s fundraiser, where 10% of your purchase will go directly to their Summer Meals Program.`,
  subSummary: ``,
  buttonText: `Shop to Support the Cause`,
  buttonLink: '/whyhunger',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Shop to support whyhunger',
    desktop: {
      src: `${urlHomepageBackground}June21_Fundraiser_Desktop2-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}June21_Fundraiser_Tablet2-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}June21_Fundraiser_Mobile2-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const earnAnIncome = {
  type: 'dynamicTile',
  enabled: true,
  key: 'JoinACommunity',
  header: 'Earn an income sharing wine from home',
  summary: `If you’re looking for a way to earn money without having to leave your home, we’re here to help. Learn more about how you can share ONEHOPE wine with friends and family, hold online tastings, and earn an income while giving back to meaningful causes. `,
  subSummary: ``,
  miniHeader: `Start a business in wine`,
  buttonText: `LEARN MORE`,
  buttonLink: '/join',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Earn an income sharing wine from home',
    desktop: {
      src: `${urlHomepageBackground}EarnAnIncome_1440x1280-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}EarnAnIncome_1536x768-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}EarnAnIncome_640x480.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const earnAnIncomeJun20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'JoinACommunity',
  header: 'Earn an income sharing wine from home',
  summary: `If you’re looking for a way to earn money without having to leave your home, we’re here to help. Learn more about how you can share ONEHOPE wine with friends and family, hold online tastings, and earn an income while giving back to meaningful causes. `,
  subSummary: ``,
  miniHeader: `Start a business in wine`,
  buttonText: `LEARN MORE`,
  buttonLink: '/join',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Earn an income sharing wine from home',
    desktop: {
      src: `${urlHomepageBackground}EarnIncome_Jun20_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}EarnIncome_Jun20_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}EarnIncome_Jun20_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const earnAnIncomeOct20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'earnAnIncomeOct20',
  header: 'Earn an income sharing wine from home',
  summary: `If you’re looking for a way to earn money without having to leave your home, we’re here to help. Learn more about how you can share ONEHOPE wine with friends and family, hold online tastings, and earn an income while giving back to meaningful causes. `,
  subSummary: ``,
  miniHeader: `Start a business in wine`,
  buttonText: `LEARN MORE`,
  buttonLink: '/join',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Earn an income sharing wine from home',
    desktop: {
      src: `${urlHomepageBackground}Oct1_Income_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Oct1_Income_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Oct1_Income_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const earnAnIncomeDec20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'earnAnIncomeDec20',
  header: 'Earn an income sharing wine from home',
  summary: `If you’re looking for a way to earn money without having to leave your home, we’re here to help. Learn more about how you can share ONEHOPE wine with friends and family, hold online tastings, and earn an income while giving back to meaningful causes. `,
  subSummary: ``,
  miniHeader: `Start a business in wine`,
  buttonText: `LEARN MORE`,
  buttonLink: '/join',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Earn an income sharing wine from home',
    desktop: {
      src: `${urlHomepageBackground}December_EarnAnIncome_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}December_EarnAnIncome_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}December_EarnAnIncome_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const earnAnIncomeJan21 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'earnAnIncomeDec20',
  header: 'Earn an Income Sharing Wine from Home',
  summary: `If you’re looking for a way to earn money without having to leave your home, we’re here to help. Learn more about how you can share ONEHOPE wine with friends and family, hold online tastings, and earn an income while giving back to meaningful causes. `,
  subSummary: ``,
  miniHeader: `Start a business in wine`,
  buttonText: `LEARN MORE`,
  buttonLink: '/join',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Earn an income sharing wine from home',
    desktop: {
      src: `${urlHomepageBackground}Jan21_EarnIncome_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Jan21_EarnIncome_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Jan21_EarnIncome_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const JoinACommunity = {
  type: 'dynamicTile',
  enabled: true,
  key: 'JoinACommunity',
  header: 'Join a community of women who have found purpose in their work',
  summary: `This month, we celebrate giving back to meaningful women’s causes, female powerhouses in the wine industry, and our passionate community of Cause Entrepreneurs who are making a difference in the world.`,
  subSummary: ``,
  miniHeader: `Start a business in wine`,
  buttonText: `LEARN MORE`,
  buttonLink: '/sipsterhood',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'Join a community of women who have found purpose in their work',
    desktop: {
      src: `${urlHomepageBackground}IWD20_3_desktop_2160x1920.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}IWD20_3_tablet_2304x1152.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}IWD20_3_mobile_960x960.jpg`,
      height: 240,
      width: 240,
    },
  },
};

export const BeYourOwnBoss = {
  type: 'dynamicTile',
  enabled: true,
  key: 'BeYourOwnBoss',
  header: 'Be your own boss',
  summary: `Join the ONEHOPE community to see how fun, flexible and rewarding it is to make an income while supporting the causes that matter to you.`,
  buttonText: `Find Out More`,
  buttonLink: '/join',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'cause entrepreneurs drinking wine',
    desktop: {
      src: `${urlHomepageBackground}founders-desktop.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}founders-tablet.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}founders-mobile.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const DrivenByPurpose = {
  type: 'dynamicTile',
  enabled: true,
  key: 'DrivenByPurpose',
  header: 'Founded by friends, driven by purpose',
  summary: `ONEHOPE began twelve years ago when a few friends asked themselves: “Why can’t you make a great bottle of wine that also serves a larger purpose?” `,
  miniHeader: `Our Mission`,
  buttonText: `Meet the Founders`,
  buttonLink: 'https://www.onehopewine.com/blog/our-founders-story',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'onehope founders enjoying Napa wine',
    desktop: {
      src: `${urlHomepageBackground}Founders_Desktop_1440x1280.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Founders_Tablet_1536x768.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Founders_Mobile_640x480.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const WeMakeWine = {
  type: 'dynamicTile',
  enabled: true,
  key: 'WeMakeWine',
  header: 'We make wine that is good for the good of others',
  summary: `Every bottle of ONEHOPE is rooted in a cause we are helping fund. We have proudly donated over $6M to causes around the world through our top quality wines. `,
  miniHeader: `Our Mission`,
  buttonText: `ABOUT US`,
  buttonLink: 'https://www.onehopewine.com/blog/our-founders-story',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'onehope founders enjoying Napa wine',
    desktop: {
      src: `${urlHomepageBackground}Founders_Desktop_1440x1280.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Founders_Tablet_1536x768.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Founders_Mobile_640x480.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const WeMakeWineJun20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'WeMakeWine',
  header: 'We make wine that is good for the good of others',
  summary: `Every bottle of ONEHOPE is rooted in a cause we are helping fund. We have proudly donated over $6M to causes around the world through our top quality wines. `,
  miniHeader: `Our Mission`,
  buttonText: `ABOUT US`,
  buttonLink: 'https://www.onehopewine.com/blog/our-founders-story',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt: 'onehope founders enjoying Napa wine',
    desktop: {
      src: `${urlHomepageBackground}WeMakeWine_Jun20_Desktop-min.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}WeMakeWine_Jun20_Tablet-min.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}WeMakeWine_Jun20_Mobile-min.jpg`,
      height: 240,
      width: 320,
    },
  },
};

export const NonProfitHighlightCureAlz = {
  type: 'dynamicTile',
  enabled: true,
  key: 'NonProfitHighlight',
  header: `Cure Alzheimer's Fund`,
  summary: `ONEHOPE is proud to support Cure Alzheimer's Fund and the amazing work they are doing to fund research to prevent, slow or reverse this disease. To date we have funded 1,552 supplies for Alzheimer's research studies.`,
  buttonText: `Learn More`,
  // Carms TODO - update this link
  buttonLink: 'https://www.onehopewine.com/blog/alzheimers-awareness-month/',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  miniHeader: 'Non-profit Highlight',
  images: {
    alt: `Cure Alzheimers Fund`,
    desktop: {
      src: `${urlHomepageBackground}NonProfitHighlight_Alzheimers_Desktop_1440x1280.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}NonProfitHighlight_Alzheimers_Tablet_1536x768.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}NonProfitHighlight_Alzheimers_Mobile_640x640.jpg`,
      height: 320,
      width: 320,
    },
  },
};

export const NonProfitHighlightOHFoundation = {
  type: 'dynamicTile',
  enabled: true,
  key: 'NonProfitHighlight',
  header: `The ONEHOPE Foundation`,
  summary: `We are so proud to announce that with the help of our community, we have reached $5 million donated to causes across the world!`,
  buttonText: `Learn More`,
  // TODO - Carms - update this link - not sure where it should go
  buttonLink: '/impact',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  miniHeader: 'Non-profit Highlight',
  images: {
    alt: `The ONEHOPE Foundation`,
    desktop: {
      src: `${urlHomepageBackground}Impact_resized_desktop_2160x1920.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}impact_resized_tablet_768x384.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}impact_resized_mobile_960x960.jpg`,
      height: 320,
      width: 320,
    },
  },
};

export const NonProfitHighlightFeb20 = {
  type: 'dynamicTile',
  enabled: true,
  key: 'NonProfitHighlight',
  header: `The Heart Foundation`,
  summary: `The Heart Foundation’s mission is to save lives by educating the public about heart disease, promoting early detection, and supporting heart health research. To date, ONEHOPE has helped to educate 121,180 people on their risks and symptoms of heart disease.

  <br><br>Every bottle of our Vintner Merlot helps to support Heart Health. `,
  buttonText: `Learn More`,
  buttonLink: 'https://theheartfoundation.org/',
  imageSide: 'left',
  textAlign: 'center',
  headerTextAlign: 'left',
  miniHeader: 'Non-profit Highlight',
  images: {
    alt: `The Heart Foundation`,
    desktop: {
      src: `${urlHomepageBackground}Heart_Health_Desktop_r.jpg`,
      height: 640,
      width: 720,
    },
    tablet: {
      src: `${urlHomepageBackground}Heart_Health_Tablet_r.jpg`,
      height: 384,
      width: 768,
    },
    mobile: {
      src: `${urlHomepageBackground}Heart_Health_Mobile.jpg`,
      height: 320,
      width: 320,
    },
  },
};

export const flashSaleWeek1Snackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo: 'to get 10% off select items',
  linkTwo: 'https://www.onehopewine.com/shop/sale',
  linkOne: '',
  promoTwoColor: '#f6f1ec',
  promoOneColor: '',
  flashSaleEndDate: '2020-11-10T07:59:59.999Z',
};

export const flashSaleWeek2Snackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo: 'to get 15% off select items',
  linkTwo: 'https://www.onehopewine.com/shop/sale',
  linkOne: '',
  promoTwoColor: '#f6f1ec',
  promoOneColor: '',
  flashSaleEndDate: '2020-11-17T07:59:59.999Z',
};

export const flashSaleWeek3Snackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo: 'to get 10% off select items',
  linkTwo: 'https://www.onehopewine.com/shop/sale',
  linkOne: '',
  promoTwoColor: '#f6f1ec',
  promoOneColor: '',
  flashSaleEndDate: '2020-11-24T07:59:59.999Z',
};

export const memorialDay21Snackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo: 'Shop our Memorial Day Sale for 20% off select wines!',
  linkTwo: 'https://www.onehopewine.com/shop/sale',
  linkOne: '',
  promoTwoColor: '#f6f1ec',
  promoOneColor: '',
  // flashSaleEndDate: '2020-11-24T07:59:59.999Z',
};

export const janFreePCSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo:
    'Free Preferred Customer membership when you subscribe to a 6 or 12 pack! Sign up',
  linkTwo: '/preferred',
  linkOne: '',
  promoTwoColor: '#f6f1ec',
  promoOneColor: '',
};

export const aprFreePCSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo:
    'Free Preferred Customer membership for this month only! Sign up',
  linkTwo: '/preferred',
  linkOne: '',
  promoTwoColor: '#f6f1ec',
  promoOneColor: '',
};

export const decFreePCSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo:
    'Preferred Customer Membership is FREE through December! Sign up now ->',
  linkTwo: '/preferred',
  linkOne: '',
  promoTwoColor: '#e4d2c4',
  promoOneColor: '',
};

export const freePCSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextTwo:
    '🤑 Preferred Customer membership is FREE through 12/31! 🤑',
  promotionTextOne:
    '📦🍷 Get FREE shipping when you subscribe to any 6- or 12-pack 🍷📦',
  linkOne: '/preferred',
  linkTwo: '/preferred',
};

export const oct1stSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextTwo: '🤑 Preferred Customer membership is FREE in November! 🤑',
  promotionTextOne:
    '📦🍷 Get FREE shipping when you subscribe to any 6- or 12-pack 🍷📦',
  linkOne: '/preferred',
  linkTwo: '/preferred',
};

export const grillChillSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne:
    '✨👢 NEW! Limited-edition LeAnn Rimes Signature Series now available! 👢✨',
  promotionTextTwo:
    '🌽🍷 Preferred Customers save up to 30% on our Grill & Chill mixed pack! 🍷🌽',
  linkOne:
    '/shop/product/leann-rimes-signature-series-paso-robles-cabernet-sauvignon',
  linkTwo: 'shop/wine/wine-collection-award-winning',
};

export const endlessSummerSnackbar2 = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne:
    '🍉☀️ NEW! Preferred Customers save 25% on the Endless Summer Mixed Pack ☀️🍉',
  promotionTextTwo: '',
  linkOne: '/shop/product/endless-summer-mixed-pack-pc',
  linkTwo: '',
};

export const endlessSummerSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne:
    '🍉☀️ NEW! Preferred Customers save 25% on the Endless Summer Mixed Pack ☀️🍉',
  promotionTextTwo:
    '🍷📦 Host a tasting event for 50% off through September 30! 📦🍷',
  linkOne: '/shop/product/endless-summer-mixed-pack-pc',
  linkTwo: '/host',
};

export const leAnnSnackbar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne:
    '✨👢 NEW! Limited-edition LeAnn Rimes Signature Series now available! 👢✨',
  promotionTextTwo:
    '🍷📦 Host a tasting event for 50% off through September 30! 📦🍷',
  linkOne:
    '/shop/product/leann-rimes-signature-series-paso-robles-cabernet-sauvignon',
  linkTwo: '/host',
};

export const promotionsSnackBarJuly19 = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  promotionTextOne:
    '🐶🐾 Shop the Pinot for Paws 2-bottle etched wood box now through 8/26 🐾😻',
  promotionTextTwo:
    '✨🇺🇸 Preferred Customers save $10 on Red, White & Blue Glitter Brut! 🇺🇸✨ ',
  linkOne: '/shop/product/2-bottle-etched-wood-box-pp-pc',
  linkTwo:
    '/shop/product/celebration-brut-sparkling-wine-red-white-blue-glitter-edition-pc',
};

export const promotionsSnackBar = {
  type: 'promotionsSnackBar',
  key: 'promotionsSnackBar',
  enabled: true,
  // promotionTextOne:
  //   '🐶🐾 Shop the Pinot for Paws 2-bottle etched wood box now through 8/26 🐾😻',
  promotionTextTwo:
    '✨🇺🇸 Preferred Customers save $10 on Red, White & Blue Glitter Brut! 🇺🇸✨ ',
  linkOne: '/shop/product/2-bottle-etched-wood-box-pp-pc',
  // linkTwo:
  //   '/shop/product/celebration-brut-sparkling-wine-red-white-blue-glitter-edition-pc',
};

export const freeShippingPromoSnackbar = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'freeShippingPromoSnackbar',
  imgSrc: `${urlHomepageBackground}FreeShippingPromoSnackbar_desktop.jpg`,
  imgWidth: 2880,
  imgHeight: 160,
  imgSrcTablet: `${urlHomepageBackground}FreeShippingPromoSnackbar_tablet.jpg`,
  imgWidthTablet: 1536,
  imgHeightTablet: 160,
  imgSrcMobile: `${urlHomepageBackground}FreeShippingPromoSnackbar_mobile.jpg`,
  imgWidthMobile: 640,
  imgHeightMobile: 160,
  imgAlt: '$0.01 Shipping on 6 and 12 Packs for Members Only!',
  imgLink: routeTheGrapefulClub,
  linkCategory: 'freeShippingPromoSnackbar',
  promotionId: 'freeShippingPromoSnackbar',
};

// halfOffTastingEvent

export const redWhiteBlueGlitterBottle = {
  type: 'halfImageHeroLeftPromo',
  enabled: true,
  key: 'redWhiteBlueGlitterBottle',
  headerTitle: `Sparkle all summer!`,
  headerTextAlign: `left`,
  summary1: `NEW! Limited Edition Red, White & Blue Glitter Celebration Brut.`,
  summary2: `Regular Price $59`,
  summary3: `Grapeful Club Price $49`,
  buttonText1: `BUY NOW`,
  buttonLink1: '/shop/wine/wine-glitter',
  useFlatButton: true,
  images: {
    desktop: {
      src: `${urlHomepageBackground}RedWhiteBlueGlitter_retouched_desktop.jpg`,
      alt: 'Shop our all new Red, White, and Blue Glitter Celebration Brut!',
      height: 1280,
      width: 1440,
    },
    mobile: {
      src: `${urlHomepageBackground}RedWhiteBlueGlitter_retouched_mobile.jpg`,
      alt: 'Shop our all new Red, White, and Blue Glitter Celebration Brut!',
      height: 480,
      width: 640,
    },
  },
};

export const grapefulExclusivesQ219 = {
  type: 'halfImageHeroLeftPromo',
  enabled: true,
  key: 'grapefulExclusivesQ219',
  headerTitle: `Members Only Perk`,
  headerTextAlign: `left`,
  summary1: `We've launched two new wines, exclusively for Grapeful Club members! As a member, you'll enjoy access to exclusive wines, special offers, and half-off shipping. Plus, ONEHOPE will donate 10% of what you spend to your charity of choice.`,
  summary2: ``,
  buttonText1: `JOIN NOW`,
  buttonLink1: '/preferred',
  useFlatButton: true,
  images: {
    desktop: {
      src: `${urlHomepageBackground}GrapefulClubExclusives_Q22019_desktop_imgOnly.jpg`,
      alt: 'Grapeful Club Exclusive Wines',
      height: 1280,
      width: 1440,
    },
    mobile: {
      src: `${urlHomepageBackground}GrapefulClubExclusives_Q22019_mobile_imgOnly.jpg`,
      alt: 'Grapeful Club Exclusive Wines',
      height: 480,
      width: 640,
    },
  },
};

export const mothersDayGifBanner19 = {
  type: 'halfImageHeroLeftPromo',
  enabled: true,
  key: 'mothersDayGifBanner19',
  headerTitle: `Make Mom's Day`,
  headerTextAlign: 'left',
  summary1: `Choose a 1 or 2 bottle limited edition etched-wood gift set with Mom's favorite varietals.`,
  summary2: `Grapeful Club member exclusive - ends May 5`,
  summary3: ``,
  buttonText1: `SHOP FOR MOM`,
  buttonLink1: '/shop/mothers-day-gifts-2019',
  useFlatButton: true,
  images: {
    desktop: {
      src: `${urlHomepageBackground}MotherDay_Hero_Desktop.gif`,
      alt: `Shop Mother's Day Exclusive Gifts`,
      height: 1280,
      width: 1280,
    },
    mobile: {
      src: `${urlHomepageBackground}MotherDay_Hero_Mobile.gif`,
      alt: `Shop Mother's Day Exclusive Gifts`,
      height: 640,
      width: 480,
    },
  },
};

export const womensMonth2019 = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'womensMonth2019',
  imgSrc: `${urlHomepageBackground}WomensHistoryMonth_Desktop.jpg`,
  imgWidth: 2880,
  imgHeight: 1110,
  imgSrcTablet: `${urlHomepageBackground}WomensHistoryMonth_Tablet.jpg`,
  imgWidthTablet: 1536,
  imgHeightTablet: 680,
  imgSrcMobile: `${urlHomepageBackground}WomensHistoryMonth_Mobile.jpg`,
  imgWidthMobile: 640,
  imgHeightMobile: 1129,
  imgAlt: 'Womens Month 2019',
  imgLink: '/join',
  linkCategory: 'womensMonth2019',
  promotionId: 'womensMonth2019',
};

export const everyBottleGivesBack = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'everyBottleGivesBack',
  imgSrc: `${urlHomepageBackground}nov19_homepage hero_desktop.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}nov19_homepage hero_tablet.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}nov19_homepage hero_mobile.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'Every Bottle Gives Back',
  imgLink: '',
  linkCategory: 'everyBottleGivesBack',
};

export const blackFridayHero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'everyBottleGivesBack',
  imgSrc: `${urlHomepageBackground}BF_Desktop_2880x1000.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}BF_Tablet_ 1536x768.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}BF_Mobile_640x480.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'Every Bottle Gives Back',
  imgLink: '/shop/wine/wine',
  linkCategory: 'everyBottleGivesBack',
};

export const celebratingFiveMillionHero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'celebratingFiveMillionHero',
  imgSrc: `${urlHomepageBackground}celebratingFiveMillion_resized_desktop_1440x500.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}celebratingFiveMillion_resized_tablet_2304x1152.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}celebratingFiveMillion_resized_mobile_960x720.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'Celebrating $5 Million',
  imgLink: '/shop/wine/wine',
  linkCategory: 'everyBottleGivesBack',
};

export const intlWomensDayHero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'intlWomensDayHero',
  imgSrc: `${urlHomepageBackground}IWD20_1_desktop_4320x1500.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}IWD20_1_tablet_2304x1152.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}IWD20_1_mobile_960x720.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'ONEHOPE celebrates International Womens Day 2020',
  imgLink: '/sipsterhood',
  linkCategory: 'everyBottleGivesBack',
};

export const apr2020Hero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'apr2020Hero',
  imgSrc: `${urlHomepageBackground}Apr1_hero_desktop-min.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}Apr1_hero_tablet-min.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}Apr1_hero_mobile_new.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'Delivering hope to your home',
  imgLink: '/',
  linkCategory: 'everyBottleGivesBack',
};

export const prideHero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'prideHero',
  imgSrc: `${urlHomepageBackground}Pride_Hero2_Desktop-min.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}Pride_Hero2_Tablet-min.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}Pride_Hero2_Mobile-min.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'Celebrating Pride',
  imgLink: '/',
  linkCategory: 'everyBottleGivesBack',
};

export const consciousKidHero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'consciousKidHero',
  imgSrc: `${urlHomepageBackground}ConsciousKid_Homepage_Hero_desktop-min.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}ConsciousKid_Homepage_Hero_tablet-min.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}ConsciousKid_Homepage_Hero_mobile-min.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'The Conscious Kid',
  imgLink: '/conscious',
  linkCategory: 'everyBottleGivesBack',
};

export const bcam2020Hero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'bcam2020Hero',
  imgSrc: `${urlHomepageBackground}Oct1_Hero_Desktop_Compressed.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}Oct1_Hero_Tablet-min.jpg`,
  imgWidthTablet: 2304,
  imgHeightTablet: 1152,
  imgSrcMobile: `${urlHomepageBackground}Oct1_Hero_Mobile-min.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'We Make Wine that is Good for the Good of Others',
  imgLink: '/about-us',
  linkCategory: 'everyBottleGivesBack',
};

export const holiday20Hero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'bcam2020Hero',
  imgSrc: `${urlHomepageBackground}November20_Hero_Desktop-min.jpg`,
  imgWidth: 4320,
  imgHeight: 2340,
  imgSrcTablet: `${urlHomepageBackground}November20_Hero_Tablet-min.jpg`,
  imgWidthTablet: 2304,
  imgHeightTablet: 1500,
  imgSrcMobile: `${urlHomepageBackground}November20_Hero_Mobile-min.jpg`,
  imgWidthMobile: 960,
  imgHeightMobile: 960,
  imgAlt: 'We Make Wine that is Good for the Good of Others',
  imgLink: '/shop/wine/wine',
  linkCategory: 'everyBottleGivesBack',
};

export const dec20Hero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'bcam2020Hero',
  imgSrc: `${urlHomepageBackground}DecemberHomepage_Hero_Desktop-min-min.jpg`,
  imgWidth: 4320,
  imgHeight: 2340,
  imgSrcTablet: `${urlHomepageBackground}DecemberHomepage_Hero_Tablet-min.jpg`,
  imgWidthTablet: 2304,
  imgHeightTablet: 1500,
  imgSrcMobile: `${urlHomepageBackground}DecemberHomepage_Hero_Mobile-min.jpg`,
  imgWidthMobile: 960,
  imgHeightMobile: 960,
  imgAlt: 'We Make Wine that is Good for the Good of Others',
  imgLink: '/shop/wine/wine',
  linkCategory: 'everyBottleGivesBack',
};

export const jan21Hero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'jan21Hero',
  imgSrc: `${urlHomepageBackground}Jan21_Hero_Desktop-min-min.jpg`,
  imgWidth: 4320,
  imgHeight: 2340,
  imgSrcTablet: `${urlHomepageBackground}Jan21_Hero_Tablet-min.jpg`,
  imgWidthTablet: 2304,
  imgHeightTablet: 1500,
  imgSrcMobile: `${urlHomepageBackground}Jan21_Hero_Mobile-min.jpg`,
  imgWidthMobile: 960,
  imgHeightMobile: 960,
  imgAlt: 'We Make Wine that is Good for the Good of Others',
  imgLink: '/shop/wine/wine',
  linkCategory: 'everyBottleGivesBack',
};

export const blackFridayHero20 = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'bcam2020Hero',
  imgSrc: `${urlHomepageBackground}BlackFriday20_Hero_Desktop-min.jpg`,
  imgWidth: 4320,
  imgHeight: 2340,
  imgSrcTablet: `${urlHomepageBackground}BlackFriday20_Hero_Tablet-min.jpg`,
  imgWidthTablet: 2304,
  imgHeightTablet: 1500,
  imgSrcMobile: `${urlHomepageBackground}BlackFriday20_Hero_Mobile-min.jpg`,
  imgWidthMobile: 960,
  imgHeightMobile: 960,
  imgAlt: 'We Make Wine that is Good for the Good of Others',
  imgLink: '/shop/wine/wine',
  linkCategory: 'everyBottleGivesBack',
};

export const weMakeWineHero = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'weMakeWineHero',
  imgSrc: `${urlHomepageBackground}HomepageHero_July_Desktop-min.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}HomepageHero_July_Tablet-min.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}HomepageHero_July_Mobile-min.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'We Make Wine that is Good for the Good of Others',
  imgLink: '/about-us',
  linkCategory: 'everyBottleGivesBack',
};

export const weMakeWineHero2 = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'weMakeWineHero2',
  imgSrc: `${urlHomepageBackground}Aug1_Homepage_Hero_Desktop-min.jpg`,
  imgWidth: 1440,
  imgHeight: 500,
  imgSrcTablet: `${urlHomepageBackground}Aug1_Homepage_Hero_Tablet-min.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 384,
  imgSrcMobile: `${urlHomepageBackground}Aug1_Homepage_Hero_Mobile-min.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 240,
  imgAlt: 'We Make Wine that is Good for the Good of Others',
  imgLink: '/about-us',
  linkCategory: 'everyBottleGivesBack',
};

export const intWomensDay2019 = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'iwd2019',
  imgSrc: `${urlHomepageBackground}IWD2019_Desktop.jpg`,
  imgWidth: 2880,
  imgHeight: 1110,
  imgSrcTablet: `${urlHomepageBackground}IWD2019_Tablet.jpg`,
  imgWidthTablet: 1536,
  imgHeightTablet: 680,
  imgSrcMobile: `${urlHomepageBackground}IWD2019_Mobile.jpg`,
  imgWidthMobile: 640,
  imgHeightMobile: 960,
  imgAlt: 'International Womens Day 2019',
  imgLink: '/join',
  linkCategory: 'iwd-2019',
  promotionId: 'iwd-2019',
};

export const valentinesImageBanner = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'valentinesBannerRecap',
  imgSrc: `${urlHomepageBackground}Valentines_Etched_Gifts_1-18_Desktop.jpg`,
  imgWidth: 2880,
  imgHeight: 1280,
  imgSrcTablet: `${urlHomepageBackground}Valentines_Etched_Gifts_1-18_Tablet.jpg`,
  imgWidthTablet: 769,
  imgHeightTablet: 1006,
  imgSrcMobile: `${urlHomepageBackground}Valentines_Etched_Gifts_1-18_Mobile.jpg`,
  imgWidthMobile: 640,
  imgHeightMobile: 968,
  imgAlt: 'Valentines Etched Gifts',
  imgLink: '/shop/valentines-day',
  linkCategory: 'valentines-day',
  promotionId: 'valentines-day',
};

// export const recap2017PromotionBanner = {
//   type: 'singleImageBanner',
//   enabled: true,
//   key: 'promotionBannerRecap',
//   imgSrc: `${urlHomepageBackground}homepage-2017-recap-hero.jpg`,
//   imgSrcMobile: `${urlHomepageBackground}homepage-2017-recap-hero-mobile.jpg`,
//   imgHeight: 744,
//   imgHeightMobile: 886,
//   imgWidth: 1488,
//   imgWidthMobile: 499,
//   imgAlt: '10 Year Anniversary Celebration and 2017 Recap',
//   imgLink: '/2017-year-in-review',
//   linkCategory: '2017-year-in-review',
//   backgroundColor: '#FFFFF',
//   promotionId: 'testpromo',
// };

// export const summerSixPackPromotionBanner = {
//   type: 'singleImageBanner',
//   enabled: true,
//   key: 'summerSixPackPromotionBanner',
//   imgSrc: `${urlHomepageBackground}six-pack-summer-sale-hero.jpg`,
//   imgSrcMobile: `${urlHomepageBackground}six-pack-summer-sale-hero-mobile.jpg`,
//   imgHeight: 720,
//   imgWidth: 1440,
//   imgHeightMobile: 320,
//   imgWidthMobile: 400,
//   imgAlt: 'Six Pack Summer Sale',
//   imgLink: '/shop/product/summer-six-pack',
//   linkCategory: 'summer-six-pack',
//   backgroundColor: '#FFFFFF',
//   promotionId: 'sixPackSummerSale',
// };

// export const ourCabCanAnimation = {
//   type: 'videoBanner',
//   enabled: true,
//   key: 'ourCabCan',
//   imgSrc: `${urlHomepageBackground}onehope_our_cab_can_desktop.mp4`,
//   imgSrcMobile: `${urlHomepageBackground}onehope_our_cab_can_mobile.mp4`,
//   imgSrcTablet: `${urlHomepageBackground}onehope_our_cab_can_tablet.mp4`,
//   fallbackImageMobile: `${urlHomepageBackground}onehope_our_cab_can_mobile_fallbackImage.gif`,
//   fallbackImageTablet: `${urlHomepageBackground}onehope_our_cab_can_tablet_fallbackImage.gif`,
//   fallbackImage: `${urlHomepageBackground}onehope_our_cab_can_desktop_fallbackImage.gif`,
//   imgHeight: 1360,
//   imgHeightMobile: 540,
//   imgHeightTablet: 400,
//   imgWidth: 2880,
//   imgWidthMobile: 320,
//   imgWidthTablet: 768,
//   imgAlt: 'Our Cabernet Can Animation',
//   imgLink: '/shop/wine/wine-cabernet',
//   linkCategory: 'wine-cabernet',
//   backgroundColor: '#FFFFF',
//   promotionId: 'ourCabCan',
// };

export const mothersDay19ImageBanner = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'mothersDay19ImageBanner',
  imgSrc: `${urlHomepageBackground}MothersDay19_homepage_desktop.jpg`,
  imgWidth: 2880,
  imgHeight: 1280,
  imgSrcTablet: `${urlHomepageBackground}MothersDay19_homepage_tablet.jpg`,
  imgWidthTablet: 768,
  imgHeightTablet: 729,
  imgSrcMobile: `${urlHomepageBackground}MothersDay19_homepage_mobile.jpg`,
  imgWidthMobile: 320,
  imgHeightMobile: 753,
  imgAlt: 'Mothers Day 2019 Exclusive Gifts',
  imgLink: '/shop/mothers-day-gifts-2019',
  linkCategory: 'mothersDay19ImageBanner',
  promotionId: 'mothersDay19ImageBanner',
};

export const springSaleImageBanner = {
  type: 'singleImageBanner',
  enabled: true,
  key: 'springSaleImageBanner',
  imgSrc: `${urlHomepageBackground}SpringSale19_hero_desktop_img.jpg`,
  imgWidth: 2880,
  imgHeight: 640,
  imgSrcTablet: `${urlHomepageBackground}SpringSale19_hero_tablet_img.jpg`,
  imgWidthTablet: 1536,
  imgHeightTablet: 580,
  imgSrcMobile: `${urlHomepageBackground}SpringSale19_hero_mobile_img.jpg`,
  imgWidthMobile: 640,
  imgHeightMobile: 648,
  imgAlt: 'Sip into Spring Sale',
  imgLink: '/preferred',
  linkCategory: 'springSaleImageBanner',
  promotionId: 'springSaleImageBanner',
};

export const springSaleBoldPack = {
  type: 'halfImageHeroLeftPromo',
  enabled: true,
  key: 'springSaleBoldPack',
  headerTitle: `Bold 6-Pack`,
  headerTextAlign: 'left',
  summary1: `4 Reds, 1 White, 1 Rosé`,
  summary2: `SALE  PRICE: $136 + $20 Shipping`,
  summary3: `CLUB PRICE: $112 + $10 Shipping`,
  buttonText1: `SHOP SALE`,
  buttonLink1: '/shop/wine/sip-into-spring-sale',
  useFlatButton: true,
  images: {
    desktop: {
      src: `${urlHomepageBackground}SpringSale19_RedsPack_desktop_notri.jpg`,
      alt: `Shop the Red Pack`,
      height: 1200,
      width: 1498,
    },
    mobile: {
      src: `${urlHomepageBackground}SpringSale19_RedsPack_mobile.jpg`,
      alt: `Shop the Red Pack`,
      height: 640,
      width: 480,
    },
  },
};

export const springSaleCrispPack = {
  type: 'halfImageHeroRight',
  enabled: true,
  key: 'springSaleCrispPack',
  headerTitle: `Crisp 6-Pack`,
  headerTextAlign: 'left',
  summary1: `3 Whites, 1 Rosé, 2 Reds`,
  summary2: `SALE  PRICE: $136 + $20 Shipping`,
  summary3: `CLUB PRICE: $112 + $10 Shipping`,
  buttonLink1: '/shop/wine/sip-into-spring-sale',
  buttonText1: `SHOP SALE`,
  useFlatButton: true,
  images: {
    desktop: {
      src: `${urlHomepageBackground}SpringSale19_WhitesPack_desktop_notri.jpg`,
      alt: `Shop the Crisp Pack`,
      height: 1200,
      width: 1498,
    },
    mobile: {
      src: `${urlHomepageBackground}SpringSale19_WhitesPack_mobile.jpg`,
      alt: `Shop the Crisp Pack`,
      height: 640,
      width: 480,
    },
  },
};

export const springSaleFullWidthBanner = {
  type: 'fullWidthBanner',
  enabled: true,
  key: 'springSaleFullWidthBanner',
  text: {
    position: 'center',
    titleLine1: 'Sip into Spring Sale',
    titleLine2: '',
    summary: `Spring into savings- get <span style="font-weight: 600">15% off</span> one of two curated half-cases of wine valued at $160. <span style="font-weight: 600">Join the Grapeful Club and double your discount!</span>`,
  },
  button: {
    style: 'black',
    text: 'Join the Club',
  },
  image: {
    altText: 'Sip into spring sale',
    linkUrl: '/preferred',
    mobileImage: {
      width: 640,
      height: 480,
      src: `${urlHomepageBackground}SpringSale19_hero_mobile.jpg`,
      styles: {
        textColor: '#0a0a0a',
        border: '1px solid #0a0a0a',
      },
    },
    tabletImage: {
      width: 1536,
      height: 432,
      src: `${urlHomepageBackground}SpringSale19_hero_tablet.jpg`,
      styles: {
        textColor: '#0a0a0a',
        border: '1px solid #0a0a0a',
      },
    },
    desktopImage: {
      width: 2880,
      height: 640,
      src: `${urlHomepageBackground}SpringSale19_hero_desktop.jpg`,
      styles: {
        textColor: '#0a0a0a',
        font: 'Gotham A',
      },
    },
  },
  promotion: {
    id: 'SpringSale19',
    position: 'HeroBanner',
  },
};

export const doingGoodTastesGreat = {
  type: 'halfImageHeroLeft',
  enabled: true,
  key: 'doingGoodTastesGreat',
  headerTitle: ` The Vintner Collection`,
  headerTextAlign: 'center',
  summary1: `This partnership between our head winemaker
Mari Coyle and Rob Mondavi, Jr. combines old world winemaking traditions with direct support
to communities in need around the world.`,
  buttonLink1: '/shop/wine/wine-collection-vintner',
  buttonText1: `SHOP THE COLLECTION`,
  images: {
    desktop: {
      src: `${urlHomepageBackground}doing-good-tastes-great-wine-desktop.jpg`,
      alt: `Doing good tastes great, drink wine`,
      height: 1440,
      width: 1440,
    },
    mobile: {
      src: `${urlHomepageBackground}doing-good-tastes-great-wine-desktop.jpg`,
      alt: `Doing good tastes great, drink wine`,
      height: 1440,
      width: 1440,
    },
  },
};

export const theGrapefulClub = {
  type: 'halfTextBoxHeroLeft',
  enabled: true,
  key: 'theGrapefulClub',
  buttonLink1: `/${routeTheGrapefulClub}`,
  buttonLink2: '/account/subscriptions',
  headerTitle: `Save money while saving the world.`,
  boxTitle: `The Grapeful Club`,
  headerTextAlign: 'left',
  summary1: `Give an additional 10% donation to your charity of choice while saving up to 20% on every shipment.`,
  summary2: `$19.99 Annual Membership Fee`,
  buttonText1: `JOIN THE CLUB`,
  buttonText2: `MY ACCOUNT`,
  images: {
    desktop: {
      src: `${urlHomepageBackground}grapeful-club-red-wine-desktop.jpg`,
      alt: `Doing good tastes great, drink wine`,
      height: 1440,
      width: 1440,
    },
    mobile: {
      src: `${urlHomepageBackground}grapeful-club-red-wine-mobile.jpg`,
      alt: `Doing good tastes great, drink wine`,
      height: 920,
      width: 640,
    },
  },
};

export const oneHopeTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'oneHopeTextBanner',
  headerTitle: 'Doing good tastes great.',
  buttonLink: '/shop/wine/wine',
  summary1: `When you shop our world-class Napa Valley wines, you give back to a wide spectrum of charitable causes.`,
  summary2: `Our community has donated over $4,867,530 to non-profits around the world.`,
  buttonText: `SHOP WITH PURPOSE`,
};

export const gatherGiveTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'gatherGiveTextBanner',
  headerTitle: 'Gather & Give',
  buttonLink: '/shop/wine/wine',
  summary1: `When you shop our world-class Napa Valley wines, you give back to a wide spectrum of charitable causes.`,
  summary2: `Our community has donated over $4,867,530 to non-profits around the world.`,
  buttonText: `SHOP WITH PURPOSE`,
};

export const intlWomensDayTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'intlWomensDayTextBanner',
  headerTitle: 'Cheers to the SIPSTERHOOD',
  buttonLink: '/sipsterhood',
  summary1: `ONEHOPE provides the tools and support to start your own business. Learn how to share great wine, earn an income, and be a part of the #sipsterhood while giving back to causes that are important to you. `,
  summary2: ``,
  buttonText: `LEARN MORE`,
};

export const deliveringHopeTextBannerSupercampaigns = {
  type: 'textBanner',
  enabled: true,
  key: 'deliveringHopeTextBanner',
  headerTitle: 'Delivering Hope to Your Home',
  useButton: true,
  useButton2: true,
  buttonLink: '/heroes',
  buttonLink2: '/hospitality',
  summary1: `As a company that was built on hope and rooted in purpose, it is our mission and responsibility to safely deliver wine to your home, and always give back to those in need. In addition to the current nonprofits that each bottle supports, we have created more opportunities for our community to fundraise for <a href="/heroes">frontline workers</a> and <a href="/hospitality">mothers in hospitality</a> during these uncertain times.`,
  summary2: ``,
  buttonText: `SUPPORT FRONTLINE WORKERS`,
  buttonText2: 'SUPPORT MOTHERS IN HOSPITALITY',
};

export const deliveringHopeTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'deliveringHopeTextBanner',
  headerTitle: 'Delivering Hope to Your Home',
  useButton: true,
  buttonLink:
    'https://www.onehopewine.com/blog/delivering-hope-during-covid-19/',
  summary1: `Your health and happiness is our #1 priority. Learn more about the measures we are taking at ONEHOPE
  to safely deliver wine to your home, and how you can support frontline workers by giving back to the COVID-19 Relief Fund through virtual events.`,
  summary2: ``,
  buttonText: `LEARN MORE`,
};

export const prideTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'prideTextBanner',
  headerTitle: 'Raise Funds & Awareness for The Trevor Project',
  useButton: true,
  buttonLink: '/pride',
  summary1: `This month marks the 50th Anniversary of Pride. While we may not be able to celebrate in person this year, there is still so much you can do to raise awareness from home. This June, we are helping Trevor support 30,000 LGBTQ youth through their lifeline, text, and chat crisis services. Shop to support this cause on <a href="/pride">The Trevor Project’s fundraising page</a> where 10% of every purchase benefits this incredible organization.`,
  summary2: ``,
  buttonText: `SHOP TO SUPPORT`,
};

export const consciousKidTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'consciousKidTextBanner',
  headerTitle: 'Help Fund Anti-Racism Books for Children',
  useButton: true,
  buttonLink: '/conscious',
  summary1: `The systemic racism and injustice in our society cannot be tolerated, and we must all do our part to stand in solidarity with the Black community. Educating children about equality and how to be actively anti-racist is imperative to nourishing the future. That’s why we’ve partnered with The Conscious Kid to help fund resources for children and their families to learn more about reducing bias. Visit our fundraiser page below where 10% of every purchase gives back to this incredible organization.`,
  summary2: ``,
  buttonText: `SHOP TO SUPPORT`,
};

export const weMakeWineTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'weMakeWineTextBanner',
  headerTitle: 'We Make Great Wine for the Good of Others',
  useButton: true,
  buttonLink: '/shop/wine/wine',
  summary1: `Every bottle of ONEHOPE makes an impact by supporting causes around the world. Together, we have proudly donated over $6 million by sharing wine and giving hope. `,
  summary2: ``,
  buttonText: `SHOP NOW`,
};

export const popFizzClinkTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'popFizzClinkTextBanner',
  headerTitle: `Pop, Fizz, Clink!`,
  // headerTitle: `<span style="font-style: normal;font-weight: 300;font-size: 32px;line-height: 44px;letter-spacing: 0.03em;">Pop, Fizz, Clink! This month only enjoy 10% off select sparkling
  // wines and an additional 5-20% off when you purchase a 4, 6, or 12-pack! Stock up for your holiday celebrations today!</span>`,
  useButton: true,
  buttonLink: 'https://www.onehopewine.com/shop/sale',
  summary1: `This month only enjoy 10% off select sparkling wines and an additional 5-20% off when you purchase a 4, 6, or 12-pack! Stock up for your holiday celebrations today!`,
  summary2: ``,
  buttonText: `SHOP NOW!`,
};

export const blackFridayTextBanner = {
  type: 'textBanner',
  enabled: true,
  key: 'blackFridayTextBanner',
  headerTitle:
    'Our biggest sale of the year is finally here! Enjoy 10% off 4-packs, 20% off 6-packs, and 35% off 12-packs for a limited time!',
  useButton: true,
  buttonLink: '/shop/wine/wine',
  summary1: ``,
  summary2: ``,
  buttonText: `SHOP NOW!`,
};

export const gatherGiveTextBannerDec3 = {
  type: 'textBanner',
  enabled: true,
  key: 'gatherGiveTextBanner',
  headerTitle: 'Gather & Give',
  buttonLink: '/shop/wine/wine',
  summary1: `When you shop our world-class Napa Valley wines, you give back to a wide spectrum of charitable causes.`,
  summary2: `Our community has donated over $5 million to non-profits around the world.`,
  buttonText: `SHOP WITH PURPOSE`,
};

export const bottomFooterTextBanner = {
  type: 'textImageBanner',
  enabled: true,
  key: 'bottomFooterTextBanner',
  imgSrc: `${urlHomepageBackground}happiness.svg`,
  imgAlt: '100% Happiness logo',
  summary: `Our #1 priority is your happiness. Which means we stand by our product 100%, no matter what. If you have a problem, we'll solve it. Just reach out to our customer support team. <span style="font-weight: 600">We’re happy when you’re happy.</span>`,
};

export const marisPicks = {
  type: 'halfImageHeroRight',
  enabled: true,
  key: 'marisPicks',
  headerTitle: `Subscribe to Mari’s Picks`,
  headerTextAlign: 'left',
  summary1: `Subscribe to Mari’s Picks to enjoy 20% off six fabulous wines every quarter, hand-selected by our own head winemaker Mari Coyle. Increase your impact by 10%, all while discovering a world of delicious wine.`,
  buttonLink1: `/${routeTheGrapefulClub}`,
  buttonText1: `SUBSCRIBE NOW`,
  images: {
    desktop: {
      src: `${urlHomepageBackground}mari-coyle-director-of-wine.jpg`,
      alt: `Mari Coyle Director of ONEHOPE Wine`,
      height: 1280,
      width: 1440,
    },
    mobile: {
      src: `${urlHomepageBackground}mari-coyle-director-of-wine.jpg`,
      alt: `Mari Coyle Director of ONEHOPE Wine`,
      height: 1280,
      width: 1440,
    },
  },
};

export const rewardsFeatureHighlight = {
  type: 'featureHighlight',
  enabled: true,
  key: 'rewards',
  title: 'Introducing ONEHOPE Rewards!',
  summary:
    'Shop, sip, and save! As a Preferred Customer you’ll now earn reward points every time you shop with us that can be redeemed for discounts on our award-winning wines, or donated to a cause you’re passionate about.',
  buttonLink: '/preferred',
  buttonText: 'Learn more',
  featureTitleOne: 'Earn Points',
  featureTitleTwo: 'Redeem or donate',
  featureTextOne:
    'Earn 5% back in points with every purchase. Double your rewards to get 10% back when you subscribe!',
  featureTextTwo:
    'Use your points on wine, or donate them to a ONEHOPE featured nonprofit!',
};

export const rewardsFeatureHighlightFeb = {
  type: 'featureHighlight',
  enabled: true,
  key: 'rewards',
  title: 'Discounts & Rewards for All!',
  summary:
    'Shop, sip, and save! Now all customers can enjoy discounts and rewards with no annual membership fee! Earn rewards with every purchase, and redeem them for discounts on our award-winning wines, or donate them to a cause you love.',
  buttonLink: '/shop',
  buttonText: 'Shop now',
  featureTitleOne: 'Everyday Savings',
  featureTitleTwo: 'Wine Club Savings',
  featureTextOne: `<ul>
<li>Save 5% on 4+ bottles, 10% on 6+ bottles, 20% on 12+ bottles</li>
<li>Half-off shipping on 4+ bottles</li>
<li>Earn 5% back in rewards with every order</li>
</ul> `,
  featureTextTwo: `<ul>
  <li>Save 5% on 4+ bottles, 10% on 6+ bottles, 20% on 12+ bottles</li>
  <li><b>FREE shipping</b> on 4+ bottles</li>
  <li>Earn <b>10% back in rewards</b> with every order</li>
  </ul> `,
};

// export const togetherWeCan = {
//   type: 'noImageBanner',
//   enabled: true,
//   key: 'togetherWeCan',
//   link: '/impact',
//   linkLabel: 'OUR IMPACT',
//   backgroundColor: '#1A1A1A',
//   fontColor: '#FFFFFF',
//   promotionId: 'togetherWeCan',
//   header: `Let’s change the world together.`,
//   subHeader: `Make a positive impact with every purchase of our world-class wines, gifts and coffee. `,
// };

// Full Width Banner

// export const serveCelebrateFullBanner = {
//   type: 'fullWidthBanner',
//   enabled: true,
//   key: 'imageGalleryServeCelebrate',
//   text: {
//     position: 'center',
//     titleLine1: 'SERVE +',
//     titleLine2: 'CELEBRATE',
//     summary: `Every <span style="font-weight: 600">ONE</span><span style="font-weight: 300">HOPE</span> product helps make our world a better place.`,
//   },
//   button: {
//     style: 'white',
//     text: 'Our Impact',
//   },
//   image: {
//     altText: 'Three married women drinking wine',
//     linkUrl: '/impact',
//     mobileImage: {
//       width: 491,
//       height: 590,
//       src: `${urlHomepageBackground}onehope-wine-celebration-hero-mobile.jpg`,
//       styles: {
//         textColor: 'white',
//         border: '1px solid white',
//       },
//     },
//     tabletImage: {
//       width: 1811,
//       height: 905,
//       src: `${urlHomepageBackground}homepage-hero-serve-celebrate.jpg`,
//       styles: {
//         textColor: 'white',
//         border: '1px solid white',
//       },
//     },
//     desktopImage: {
//       width: 1811,
//       height: 905,
//       src: `${urlHomepageBackground}homepage-hero-serve-celebrate.jpg`,
//       styles: {
//         textColor: 'white',
//       },
//     },
//   },
//   promotion: {
//     id: 'ServeCelebrate',
//     position: 'HeroBanner',
//   },
// };

// Right Image Banner

export const wineKnotRightImageBanner = {
  type: 'fullWidthBanner',
  enabled: true,
  key: 'rightImageWineknot',
  text: {
    position: 'left',
    titleLine1: '',
    titleLine2: '#WINEKNOT',
    summary: `Turn your special day into an opportunity to make an impact. Learn more about <span style="font-weight: 600">ONE</span><span style="font-weight: 300">HOPE</span> Weddings.`,
  },
  button: {
    style: 'purple',
    text: 'LEARN MORE',
  },
  image: {
    mobileImage: {
      width: 509,
      height: 612,
      src: `${urlHomepageBackground}20180131glitterWeddingsMobile.jpg`,
      styles: {
        textColor: 'white',
        border: '1px solid white',
      },
    },
    tabletImage: {
      width: 798,
      height: 311,
      src: `${urlHomepageBackground}20180131glitterWeddingsTablet.jpg`,
      styles: {
        textColor: 'white',
        border: '1px solid white',
      },
    },
    desktopImage: {
      width: 1958,
      height: 979,
      src: `${urlHomepageBackground}20180131glitterWeddingsDesktop.jpg`,
      styles: {
        textColor: '#0a0a0a',
      },
    },
    altText: 'Emerald wedding ring next to a ONEHOPE gold glitter bottle',
    linkUrl: '/weddings',
  },
};

// export const viaHostsRightImageBanner = {
//   type: 'fullWidthBanner',
//   enabled: true,
//   key: 'rightImageFreeGiftForHosts',
//   text: {
//     position: 'left',
//     titleLine1: 'FREE GIFT',
//     titleLine2: 'FOR HOSTS',
//     summary: `Host a qualified via<span style="font-weight: 600">ONE</span><span style="font-weight: 300">HOPE</span> tasting event in February and get a free 3-item gift!`,
//   },
//   button: {
//     style: 'purple',
//     text: 'LEARN MORE',
//   },
//   image: {
//     mobileImage: {
//       width: 640,
//       height: 770,
//       src: `${urlHomepageBackground}20180131BubbleStopperMobile.jpg`,
//       styles: {
//         textColor: 'white',
//         border: '1px solid white',
//       },
//     },
//     tabletImage: {
//       width: 798,
//       height: 311,
//       src: `${urlHomepageBackground}20180131BubbleStopperTablet.jpg`,
//       styles: {
//         textColor: 'white',
//         border: '1px solid white ',
//       },
//     },
//     desktopImage: {
//       width: 1958,
//       height: 979,
//       src: `${urlHomepageBackground}20180131BubbleStopperDesktop.jpg`,
//       styles: {
//         textColor: '#0a0a0a',
//       },
//     },
//     altText: 'wine bubble stopper with cork',
//     linkUrl: 'https://www.viaonehope.com/host-an-event/',
//   },
// };

// Left Image Banner
// export const mothersDayGiftGuide2018 = {
//   type: 'halfWidthImageBanner',
//   enabled: true,
//   key: 'leftImageMothersDayGiftGuide2018',
//   text: {
//     position: 'right',
//     titleLine1: `MOTHER'S DAY`,
//     titleLine2: 'GIFT GUIDE',
//     summary: `Shop our curated collection of wine and gifts for the special lady in your life.`,
//   },
//   button: {
//     style: 'purple',
//     text: 'SHOP NOW',
//   },
//   image: {
//     mobileImage: {
//       width: 509,
//       height: 612,
//       src: `${urlHomepageBackground}2018_05_01_Mothersday_Mobile.jpg`,
//       styles: {
//         textColor: 'white',
//         border: '1px solid white',
//       },
//     },
//     tabletImage: {
//       width: 600,
//       height: 612,
//       src: `${urlHomepageBackground}2018_05_01_Mothersday_Desktop.jpg`,
//       styles: {
//         textColor: 'white',
//         border: '1px solid white',
//       },
//     },
//     desktopImage: {
//       width: 1958,
//       height: 979,
//       src: `${urlHomepageBackground}2018_05_01_Mothersday_Desktop.jpg`,
//       styles: {
//         textColor: '#0a0a0a',
//       },
//     },
//     altText: 'ONEHOPE glitter bottle with pancakes and fruits',
//     linkUrl: '/shop/gifts/gift',
//   },
// };

// Image Gallery

export const bestSellersImageGallery = {
  type: 'imageGallery',
  enabled: true,
  key: 'imageGalleryBestSellers',
  galleryId: 'bestSellers',
  galleryTitle: 'Best Sellers',
  newCategory: 'wine-best-selling',
  headerUrl: '/wine/wine-best-selling',
};

export const newArrivalsImageGallery = {
  type: 'imageGallery',
  enabled: true,
  key: 'imageGalleryNewArrivals',
  galleryId: 'newArrivals',
  galleryTitle: 'New Arrivals',
  newCategory: 'wine',
  headerUrl: '',
};

// Shop By Categories

// export const shopByCategories = {
//   type: 'shopCategory',
//   enabled: true,
//   key: 'shopCategories',
//   category1: {
//     title: 'wine',
//     src: `${urlHomepageCategory}Wine.jpg`,
//     alt: 'multiple ONEHOPE wines',
//     linkUrl: '/shop/wine/wine',
//   },
//   category2: {
//     title: 'gifts',
//     src: `${urlHomepageCategory}Gifts.jpg`,
//     alt: '1 ONEHOPE Gift box',
//     linkUrl: '/shop/gifts/gift',
//   },
//   category3: {
//     title: 'kitchen',
//     src: `${urlHomepageCategory}Kitchen.jpg`,
//     alt: '4 bottles of marinade and BBQ sauces',
//     linkUrl: '/shop/kitchen/kitchen',
//   },
// };
//

export const tastingKitPromo = {
  type: 'tastingKit',
  enabled: true,
  key: 'tastingKit',
  imageSide: 'right',
  textAlign: 'center',
  headerTextAlign: 'left',
  images: {
    alt:
      'Try four of our best-selling wines for $29, from the comfort of your own home.',
    desktop: {
      src: `${urlHomepageBackground}Jan21_Fundraiser_Desktop-min-min.jpg`,
      height: 1920,
      width: 2160,
    },
    tablet: {
      src: `${urlHomepageBackground}Jan21_Fundraiser_Tablet-min.jpg`,
      height: 1152,
      width: 2304,
    },
    mobile: {
      src: `${urlHomepageBackground}Jan21_Fundraiser_Mobile-min.jpg`,
      height: 720,
      width: 960,
    },
  },
};

export const tastingKitSnackBar = {
  type: 'tastingKitSnackBar',
  key: 'tastingKitSnackBar',
  enabled: true,
  promotionTextOne: '',
  promotionTextTwo: 'Shop our new Tasting Flights',
  linkOne: '',
  linkTwo: 'https://www.onehopewine.com/tasting-flight',
  promoOneColor: '',
  promoTwoColor: '#FAF6F3',
  textOneColor: '',
  textTwoColor: '#8A4A29',
};
